import { BsFillCloudUploadFill } from "react-icons/bs";
import { FaPlus } from "react-icons/fa";
import { IoIosCloudDone } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiFillWarning } from "react-icons/ai";

export const ObjectStatus = {
  New: 0,
  Sync: 1,
  Updated: 2,
  Deleted: 3
};

export const StatusIcon = ({ status }) => {
  const getStatusIcon = () => {
    switch (status) {
      case ObjectStatus.New:
        return <FaPlus />;
      case ObjectStatus.Sync:
        return <IoIosCloudDone />;
      case ObjectStatus.Updated:
        return <BsFillCloudUploadFill />;
      case ObjectStatus.Deleted:
        return <RiDeleteBin6Line />;
      default:
        return <AiFillWarning style={{ color: "red" }} />;
    }
  };

  return <>{getStatusIcon()}</>;
};

export function updateStatus(currentStatus, newStatus) {
  return currentStatus == ObjectStatus.New ? ObjectStatus.New : newStatus;
}
